import { Action, createReducer, on } from '@ngrx/store'
import { saleItemSurveyDraftActions } from './sale-item-survey-draft.actions'
import { SaleItemSurveyDraft } from './sale-item-survey-draft.model'

export const FEATURE_NAME = 'saleItemSurveyDrafts'

export interface SaleItemSurveyDraftState {
  drafts: SaleItemSurveyDraft[]
}

export const initialState: SaleItemSurveyDraftState = {
  drafts: []
}

const reducer = createReducer(
  initialState,
  on(saleItemSurveyDraftActions.upsertOne, (state, { draft }) => ({
    ...state,
    drafts: [
      ...state.drafts.filter((item) => item.saleItemId !== draft.saleItemId),
      draft
    ]
  })),
  on(saleItemSurveyDraftActions.upsertMany, (state, { drafts }) => ({
    ...state,
    drafts: [
      ...state.drafts.filter(
        (item) => !drafts.some((draft) => draft.saleItemId === item.saleItemId)
      ),
      ...drafts
    ]
  })),
  on(saleItemSurveyDraftActions.removeBySaleItemId, (state, { saleItemId }) => ({
    ...state,
    drafts: state.drafts.filter((draft) => draft.saleItemId !== saleItemId)
  })),
  on(saleItemSurveyDraftActions.resetState, () => ({
    ...initialState
  }))
)

export function saleItemSurveyDraftReducer(
  state: SaleItemSurveyDraftState | undefined,
  action: Action
): SaleItemSurveyDraftState {
  return reducer(state, action)
}
